import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="global-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img 
            src="/logo.jpg" 
            alt="Amegnona Club Logo" 
            className="footer-logo-img"
          />
          <div className="footer-text">
            <h3>AMEGNONA CLUB</h3>
            <p>Unity • Brotherhood • Community</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;